import React, { Component } from 'react'


export class ReceptionSidebar extends Component {
    render() {
        return (
            <div>

                <div className="sidebar-container">
                    {/* <div className="sidebar-logo">
						Project Name
					</div> */}
                    
                    <ul className="sidebar-navigation">
                        <li className="header"></li>
                        <li>
                            <a href="/input/patient/details">
                                <i className="fa fa-home" aria-hidden="true"></i> New Patient Details
                            </a>
                        </li>
                        <li>
                            <a href="/search/patient">
                                <i className="fa fa-tachometer" aria-hidden="true"></i> Search Patient Details
                            </a>
                        </li>
                        {/* <li className="header">Another Menu</li> */}
                        <li>
                            <a href="/confirm/patient">
                                <i className="fa fa-users" aria-hidden="true"></i> Confirm Patient
                            </a>
                        </li>
                        {/* <li>
                            <a href="/get/bill/ticket">
                                <i className="fa fa-cog" aria-hidden="true"></i> Billing
                            </a>
                        </li> */}

                    
                    </ul>
                </div>
            </div>
        )
    }
}